var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('input',{ref:"excelUploader",attrs:{"id":"excel-uploader","type":"file","multiple":_vm.multiple},on:{"change":_vm.onChange}}),_c('span',{on:{"click":_vm.onClick}},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }